import React, { ReactNode } from "react";
import Row from "@amzn/meridian/row";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import { BoxType } from "@amzn/meridian/box/box";

export interface IInformationPanelAttributes {
    title?: string;
    rows: IRowAttributes[];
    height: string;
    type?: BoxType;
    spacingInset?: string;
}

export interface IRowAttributes {
    columns: IColumnAttributes[];
}

export interface IColumnAttributes {
    label: string;
    value: ReactNode;
}

const AttributesPanel: React.FC<IInformationPanelAttributes> = ({
    title,
    rows,
    height,
    type,
    spacingInset,
}) => {
    return (
        <Box type={type} height={height} spacingInset={spacingInset}>
            {title && (
                <Row width="100%" height="45px" alignmentVertical="top">
                    <Text color="primary" type="h200">
                        {title}
                    </Text>
                </Row>
            )}

            {rows.map((row, rowIndex) => (
                <React.Fragment key={rowIndex}>
                    <Row
                        width="100%"
                        widths={row.columns.map(() => `${100 / row.columns.length}%`)}
                    >
                        {row.columns.map(({ label }, columnIndex) => (
                            <Text key={columnIndex} color="secondary" type="b300">
                                {label}
                            </Text>
                        ))}
                    </Row>

                    <Row
                        width="100%"
                        height="40px"
                        alignmentVertical="top"
                        widths={row.columns.map(() => `${100 / row.columns.length}%`)}
                    >
                        {row.columns.map(({ value }, columnIndex) => (
                            <Box key={columnIndex} spacingInset="100 none none none">
                                {value}
                            </Box>
                        ))}
                    </Row>
                </React.Fragment>
            ))}
        </Box>
    );
};

export default AttributesPanel;
